// PrintBorangPenyerahan.js
// Generates the "Borang Pengesahan Penyerahan Dokumen" form per provided rows
// rows: [ { nama, alamat1_pelanggan, alamat2_pelanggan, poskod_pelanggan, bandar_pelanggan, negeri_pelanggan, no_tel } ]

// Now we bypass the borang-penyerahan endpoint and fetch selected accounts directly
import { apiGetAkaunBatchByNoAkaun } from "../../api/akaun";

function fmt(v) { return (v ?? '').toString().trim(); }
function addressLine(r) {
  const parts = [fmt(r.alamat1_pelanggan), fmt(r.alamat2_pelanggan)].filter(Boolean);
  return parts.join(', ');
}
function addressCity(r) {
  const parts = [fmt(r.poskod_pelanggan), fmt(r.bandar_pelanggan), fmt(r.negeri_pelanggan)].filter(Boolean);
  return parts.join(' ');
}

export async function printBorangPenyerahan(zon, noAkauns = []) {
  const today = new Date();
  const todayStr = today.toLocaleDateString('en-GB');
  const month = today.toLocaleDateString('en-GB', { month: 'long' });
  const year = today.getFullYear();
  const monthNum = String(today.getMonth() + 1).padStart(2, '0');
  const uniq = Array.from(new Set((Array.isArray(noAkauns) ? noAkauns : []).filter(Boolean).map(String)));
  const kawasanPremis = (zon && String(zon).trim()) ? String(zon).trim() : '.................................................................';
  // Fetch batch account data
  let rows = [];
  try {
    const resp = await apiGetAkaunBatchByNoAkaun(uniq);
    rows = Array.isArray(resp?.data) ? resp.data : [];
  } catch (e) {
    window.appNotify && window.appNotify({ color: 'error', icon: 'error', title: 'Ralat', content: e.message || 'Gagal memuat data akaun.' });
    return;
  }
  // Final sort alphabetically by nama (case-insensitive) per requirement
  rows = [...rows].sort((a,b) => {
    const an = (a.nama||'').toLowerCase();
    const bn = (b.nama||'').toLowerCase();
    if (an < bn) return -1; if (an > bn) return 1; return 0;
  });

  const tableRowsHtml = rows.map((r, idx) => {
    const perkaraCode = 'LKJT 600-8/3/191 (&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;) - STAIL';
    const perkara = `${perkaraCode}<br/>${fmt(r.nama)}`;
    const addr1 = addressLine(r);
    const addr2 = addressCity(r);
    return `
      <tr>
        <td style="text-align:center;">${idx + 1}</td>
        <td style="text-align:center;">${todayStr}</td>
        <td>${perkara}</td>
        <td></td>
        <td>${addr1}<br/>${addr2}</td>
        <td></td>
        <td style="text-align:center;">${fmt(r.no_tel)}</td>
      </tr>
    `;
  }).join('');

  const logoUrl = window.location.origin + "/build/kejora.png";

  const html = `
  <html>
    <head>
      <title>Borang Pengesahan Penyerahan Dokumen</title>
      <style>
        @media print { @page { size: A4 landscape; margin: 1mm; } body { margin: 0; } }
        body { font-family: Arial, sans-serif; margin: 16px; }
        .header { text-align: center; margin-bottom: 10px; }
        .logo { width: 80px; margin-bottom: 20px; }
        .title { font-weight: bold; font-size: 12px; }
        .month { margin-top: 10px; font-weight: bold; font-size: 12px; }
        table { border-collapse: collapse; width: 100%; margin-top: 8px; }
        th, td { border: 1px solid #000; padding: 6px 8px; font-size: 10px; vertical-align: top; }
        th { background: #f0f0f0; text-align: center; }
        .notes { font-size: 11px; margin-top: 12px; }
      </style>
    </head>
    <body>
      <div class="header">
        <img class="logo" src="${logoUrl}" />
        <div class="title">LEMBAGA KEMAJUAN JOHOR TENGGARA</div>
        <div class="title">BORANG PENGESAHAN PENYERAHAN DOKUMEN</div>
  <div class="month">BAGI BULAN <u>${monthNum}</u> TAHUN <u>${year}</u></div>
      </div>
  <div style="margin-bottom:10px;margin-top:20px; font-size: 12px;">KAWASAN PREMIS : <strong>${kawasanPremis}</strong></div>
      <table>
        <thead>
          <tr>
            <th style="width:40px;">BIL</th>
            <th style="width:80px;">TARIKH</th>
            <th style="width:240px;">TAJUK SURAT / PERKARA</th>
            <th style="width:160px;">COP RASMI DAN TANDATANGAN</th>
            <th style="width:260px;">ALAMAT TEMPAT TINGGAL</th>
            <th style="width:80px;">TARIKH & MASA DOKUMEN DITERIMA</th>
            <th style="width:100px;">NO. TEL</th>
          </tr>
        </thead>
        <tbody>
          ${tableRowsHtml}
        </tbody>
      </table>
      <div style="display:flex; gap:32px; justify-content:space-between; margin-top:20px;">
        <div style="font-size:12px;">Disediakan oleh :<br/><br/>..................................................</div>
        <div style="font-size:12px;">Disemak dan disokong oleh :<br/><br/>..................................................</div>
        <div style="font-size:12px;">Disahkan dan diluluskan oleh :<br/><br/>..................................................</div>
      </div>
      <div class="notes">
        Nota :-<br/>
        1. Dokumen ini adalah untuk pemantauan sahaja, walau bagaimanapun pengisian ke dalam STAIL adalah diwajibkan.<br/>
        2. Dokumen ini adalah sebagai bukti arahan tugas rasmi yang dilakukan bagi penyerahan dokumen, surat, notis, pesanan tempatan(LO), penyerahan barang-barang bantuan dan sebagainya.<br/>
        3. Borang ini hendaklah disahkan disetiap muka surat yang dinyatakan bukti penyerahan.
      </div>
      <script>
        function imagesLoaded(doc, cb){var imgs = doc.images; if(!imgs||!imgs.length) return cb(); var n=0; var fn=function(){ if(++n>=imgs.length) cb(); }; for(var i=0;i<imgs.length;i++){ if(imgs[i].complete) fn(); else imgs[i].addEventListener('load', fn, false); imgs[i].addEventListener('error', fn, false);} }
        imagesLoaded(document, function(){ window.print(); });
      </script>
    </body>
  </html>`;

  const win = window.open('', '_blank');
  win.document.open();
  win.document.write(html);
  win.document.close();
}

export default printBorangPenyerahan;
